import {dataSidebar} from "./dataSidebar";
import WebLogo from '../../font & image/image/webLogo.png'
import {useLocation, useNavigate, useNavigation} from "react-router-dom";


export default function SideBar() {

    const navigate = useNavigate();
    const location = useLocation();

    return (

        <div className='min-h-screen  max-h-[100vh]'>

            <div className="flex items-center gap-3 justify-center mt-4 ">

                <div className="text-[32px] text-white italic flex items-center justify-center">
                    Bot Markets
                </div>
                <img src={WebLogo} alt="logo" height={42} width={42}/>
            </div>


            <ul className="flex flex-col gap-1 text-xl mt-3 ">
                {dataSidebar.map(item =>
                    <li className={`flex py-2 px-5 gap-2 items-center ${location.pathname === item.link ? "text-bg-secondColor-shade7 bg-white" : "text-white hover:-translate-x-3"} duration-500 hover:cursor-pointer`}
                        key={item.link}
                        onClick={() => navigate(item.link)}
                    >
                        {item.icon}
                        {item.title}
                    </li>
                )}
            </ul>


        </div>
    )
}